import '../scss/bundle.scss'
import GLightbox from 'glightbox'

import initAlpine from './modules/Alpine.js'
import animation from './modules/animation.js'
import initMasonry from './modules/masonry.js'
import batchLoadMore from './modules/batchLoadMore.js'

let go = () => {
  initAlpine()
  animation()
  initMasonry()
  batchLoadMore()
  GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    closeOnOutsideClick: true,
  })
}

window.addEventListener('DOMContentLoaded', go)
